import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Channels {
  user: string;
  conversations: string[];
}

interface RealtimeResponse {
  identity: string;
  token: string;
  channels: Channels;
}

type UserId = number | 'me';

export type GetRealtimeTokenCall = (userId: UserId) => Promise<{
  data: RealtimeResponse;
  status: number;
}>;

export default (makeCall: MakeCall) => (userId: UserId) =>
  makeCall<RealtimeResponse>('GET', `/api/v2/user/${userId}/realtime`);
